<div class="line">
  <div class="line-outer">
    <div class="header">
      <a
        routerLink="/org/{{ orgId }}/space/{{ spaceId }}/edit"
        class="white-text header-shadow"
      >
        User:
      </a>
    </div>
    <div class="middle-section">
      <a
        *ngIf="userSelected"
        [routerLink]="preserveTaskIdPath"
        [queryParams]="{ userId: null }"
        queryParamsHandling="merge"
        class="bubble highlight"
      >
        <span class="tick">✓</span>
        <span class="cross">✕</span>
        {{ userSelected.name }}
      </a>

      <a
        *ngIf="noUser"
        [routerLink]="preserveTaskIdPath"
        [queryParams]="{ userId: null }"
        queryParamsHandling="merge"
        class="bubble highlight"
      >
        <span class="tick">✓</span>
        <span class="cross">✕</span>
        No user
      </a>

      <div
        *ngIf="(userSelected && usersRemaining.length) || noUser"
        class="spacer white-text header-shadow"
      >
        |
      </div>
      <a
        *ngFor="let user of usersRemaining"
        [routerLink]="removeTaskIdPath"
        [queryParams]="{ userId: user._id }"
        queryParamsHandling="merge"
        class="bubble"
      >
        {{ user.name }}
      </a>

      <div *ngIf="!noUser" class="spacer white-text header-shadow">|</div>

      <a
        *ngIf="!noUser"
        [routerLink]="removeTaskIdPath"
        [queryParams]="{ userId: '0' }"
        queryParamsHandling="merge"
        class="bubble"
      >
        No user
      </a>
    </div>

    <div>
      <button
        mat-icon-button
        class="more-button header-shadow"
        (click)="launchUserDialog()"
        aria-label="Change user filter"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="line">
  <div class="line-outer">
    <div class="header">
      <a
        routerLink="/org/{{ orgId }}/space/{{ spaceId }}/tags"
        class="white-text header-shadow"
        >Tags:</a
      >
    </div>
    <div class="middle-section">
      <a
        *ngIf="tags.length === 0"
        routerLink="/org/{{ orgId }}/space/{{ spaceId }}/tags"
        class="header white-text header-shadow"
      >
        Edit tags
      </a>
      <a
        *ngFor="let tag of tagsSelected"
        [routerLink]="preserveTaskIdPath"
        [queryParams]="{ tagId: deselectTagLink(tag._id) }"
        queryParamsHandling="merge"
        class="bubble highlight"
      >
        <span class="tick">✓</span>
        <span class="cross">✕</span>
        {{ tag.name }}
      </a>
      <a
        *ngIf="noTags"
        [routerLink]="preserveTaskIdPath"
        [queryParams]="{ tagId: null }"
        queryParamsHandling="merge"
        class="bubble highlight"
      >
        <span class="tick">✓</span>
        <span class="cross">✕</span>
        No tags
      </a>
      <div
        *ngIf="(tagsSelected.length || noTags) && tagsRemaining.length"
        class="spacer white-text header-shadow"
      >
        |
      </div>
      <a
        *ngFor="let tag of tagsRemaining"
        [routerLink]="removeTaskIdPath"
        [queryParams]="{ tagId: tagIds.concat(tag._id) }"
        queryParamsHandling="merge"
        class="bubble"
      >
        {{ tag.name }}
      </a>
      <div
        *ngIf="(tagsSelected.length || tagsRemaining.length) && !noTags"
        class="spacer white-text header-shadow"
      >
        |
      </div>
      <a
        *ngIf="!noTags"
        [routerLink]="removeTaskIdPath"
        [queryParams]="{ tagId: '0' }"
        queryParamsHandling="merge"
        class="bubble"
      >
        No tags
      </a>
    </div>

    <div>
      <button
        mat-icon-button
        class="more-button header-shadow"
        (click)="launchTagDialog()"
        aria-label="Change tag filter"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>
  </div>
</div>
